import(/* webpackMode: "eager" */ "/Users/shenbagakrithika/Documents/Boo Stuff/instrutech/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/shenbagakrithika/Documents/Boo Stuff/instrutech/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/shenbagakrithika/Documents/Boo Stuff/instrutech/src/components/ui/AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/shenbagakrithika/Documents/Boo Stuff/instrutech/src/components/ui/AppLogo.tsx");
